import Vue from 'vue'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getNotReadCount } from '@/api/chat'

import { getToken } from '@/utils/auth'
import { getNotSolveFaultBack } from '@/api/appManage'
// ws 連線站台網址
const wsUrl = process.env.VUE_APP_APP_WS
var socketGroup
var token = getToken()
const key = 'ItaApp'

const emitter = new Vue({
  methods: {
    send(message) {
      // console.log('群組聊天傳送訊息', message)
      if (socketGroup.readyState === 1) {
        socketGroup.send(JSON.stringify(message))
      }
    },
    onBaseSocketOpen() {
      const vm = this
      var t = setInterval(function () {
        if (socketGroup.readyState != 1) {
          clearInterval(t)
          return
        }
        vm.socketSendPing()
      }, 55000)
      //55000
    },
    socketSendPing() {
      const vm = this
      var payload = {
        type: 66,
      }
      socketGroup.send(JSON.stringify(payload))
    },
    close() {
      if (socketGroup && socketGroup.readyState == WebSocket.OPEN) {
        socketGroup.close()
        // console.log('群組聊天WebSocket Closed.')
      }
    },
    connect() {
      const vm = this
      token = getToken()
      // alert('onSocket {token: ' + token + '}')
      if (typeof token !== 'undefined') {
        const type = '3' // 配合APP群組聊天
        const wsUrlWithType = `${wsUrl}?type=${type}`
        // console.log('websocket wsUrlWithType=', wsUrlWithType)
        socketGroup = new WebSocket(wsUrlWithType, [key, token])

        socketGroup.onopen = function (event) {
          vm.onBaseSocketOpen()
          // console.log('群組聊天WebSocket連線成功')
          // Message({
          //   message: "即時訊息服務器連線成功。",
          //   type: "success",
          //   duration: 2 * 1000,
          // });
          // Message({
          //   message: '即時訊息服務器連線成功。',
          //   type: 'success',
          //   duration: 5 * 1000
          // })
          emitter.$emit('open')
          if (!store.getters.account) {
            return
          }
          getNotReadCount({ account: store.getters.account }).then(response => {
            const count = parseInt(response.data)
            store.dispatch('app/setMessage', parseInt(count))
          })
        }
        socketGroup.onmessage = function (msg) {
          // console.log('收到群組聊天訊息', msg)

          emitter.$emit('message', msg)
          if (!store.getters.account) {
            return
          }
          getNotReadCount({ account: store.getters.account }).then(response => {
            const count = parseInt(response.data)
            store.dispatch('app/setMessage', parseInt(count))
          })

          // console.log("接收到服務端訊息：");
        }
        socketGroup.onerror = function (err) {
          emitter.$emit('error', err)
          // console.log('群組聊天WebSocket連線發生錯誤')
          // Message({
          //   message: "即時訊息服務器無法連接，請檢查您的網路。",
          //   type: "error",
          //   duration: 5 * 1000,
          // });
        }
        socketGroup.onclose = function () {
          emitter.connect()
          // console.log('群組聊天WebSocket連線關閉')
          // Message({
          //   message: "即時訊息服務器已斷線，請檢查您的網路。",
          //   type: "error",
          //   duration: 2 * 1000,
          // });
        }
      }
    },
  },
})

// emitter.connect()
export default emitter
